var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBettingUser = function SvgBettingUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.9,
    d: "M6.666 1.833a4 4 0 0 1 2.426 7.179c.494.218.958.502 1.379.847l.165.141.091.099a.667.667 0 0 1-.864.98L9.753 11l-.26-.214a4.67 4.67 0 0 0-6.747 1.182A4.67 4.67 0 0 0 2 14.5a.667.667 0 0 1-1.334 0 6 6 0 0 1 3.532-5.47l.041-.018a4 4 0 0 1 2.427-7.179m7.53 9.528a.668.668 0 0 1 .943.944l-2.667 2.666a.666.666 0 0 1-.943 0l-1.334-1.333-.085-.105a.667.667 0 0 1 .924-.924l.105.086.861.862z"
  })));
};
export default SvgBettingUser;